import i18next from 'i18next'
import moment from 'moment'

export const formatTimelineDate = (date: Date) => {
    const momentDate = moment(date)
    const momentNow = moment()

    const year = momentDate.format('YYYY')
    const dayMonth = momentDate.format('MMM DD')
    const time = momentDate.format('h:mm A')

    if (momentDate.year() === momentNow.year()) {
        return i18next.t('appcore:TimelineComment.timestampWithoutYear', { dayMonth, time })
    }

    return i18next.t('appcore:TimelineComment.timestampWithYear', { dayMonth, time, year })
}
